import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import { Button } from "react-bootstrap";
import ReactSelect from "../../UI/ReactSelect";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
export default function Filter(props) {
  const { onHide, show, filterInputsUpdate, filterInputs, setFilterInputs, devicePlaceId, deviceModelId, deviceTypeId } = props;
  const [chooseOption, setChooseOption] = useState([]);
  const [chooseModelOption, setChooseModelOption] = useState([]);
  const [chooseTypeOption, setChooseTypeOption] = useState([]);

  function handleChangePlace(value) {
    setChooseOption(value);
    filterInputsUpdate("devicePlaceId", value.value);

  }
  function handleChangeModel(value) {
    setChooseModelOption(value);
    filterInputsUpdate("deviceModelId", value.value);

  }
  function handleChangeType(value) {
    setChooseTypeOption(value);
    filterInputsUpdate("deviceTypeId", value.value);

  }

  const onResetFilter = () => {
    setFilterInputs({
      appointment: "",
      direction: "",
      ipAddress: "",
      name: "",
      status: "",
    });
    setChooseOption(null)
    setChooseModelOption(null);
    setChooseTypeOption(null);
    onHide(false)
  }
  const [open, setOpen] = React.useState(false);

  function handleClose() {
    setOpen(false);
  }

  function handleOpen() {
    setOpen(true);
  }


  return (
    <Modal
      size="md"
      show={show}
      onHide={onHide}
      aria-labelledby="create"
      centered
      className="modal pr-0"
    >
      <Modal.Header closeButton>
        <Modal.Title id="create">Qurğular hesabatı filtri</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 pl-4 pr-4">
          <div className="row">
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="name"
                  name="name"
                  label="Qurğu adı "
                  placeholder="Qurğu adı "
                  className="w-100"
                  value={filterInputs.name}
                  onChange={(e) =>
                    filterInputsUpdate("name", e.target.value)
                  }
                // onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>

            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <FormControl className="w-100">
                  <InputLabel htmlFor="role">Status </InputLabel>
                  <Select
                    open={open}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    value={filterInputs.status}
                    onChange={(e) =>
                      filterInputsUpdate("status", e.target.value)
                    }
                    inputProps={{
                      name: "status",
                      id: "status",
                    }}
                  >
                    <MenuItem value="ONLINE">Online</MenuItem>
                    <MenuItem value="DELETED">Offline</MenuItem>


                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="ipAddress"
                  name="ipAddress"
                  label="İp ünvanı  "
                  placeholder="İp ünvanı  "
                  className="w-100"
                  value={filterInputs.ipAddress}
                  onChange={(e) =>
                    filterInputsUpdate("ipAddress", e.target.value)
                  }
                // onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="direction"
                  name="direction"
                  label="İstiqamət"
                  placeholder="İstiqamət"
                  className="w-100"
                  value={filterInputs.direction}
                  onChange={(e) =>
                    filterInputsUpdate("direction", e.target.value)
                  }
                // onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <ReactSelect
                  suggestions={devicePlaceId}
                  handleChangeSingle={(value) => handleChangePlace(value)}
                  single={chooseOption}
                  label="Qurğu məkanı  seçin"
                  placeholder="Qurğu məkanı seçin"
                  inputId="devicePlaceId"
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <ReactSelect
                  suggestions={deviceModelId}
                  handleChangeSingle={(value) => handleChangeModel(value)}
                  single={chooseModelOption}
                  label="Qurğu modeli  seçin"
                  placeholder="Qurğu modeli seçin"
                  inputId="deviceModelId"
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <ReactSelect
                  suggestions={deviceTypeId}
                  handleChangeSingle={(value) => handleChangeType(value)}
                  single={chooseTypeOption}
                  label="Qurğu tipi  seçin"
                  placeholder="Qurğu tipi seçin"
                  inputId="deviceTypeId"
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end">  <Button
            variant="primary"
            onClick={() => {
              onResetFilter();
            }}
            className="mt-4"
          >
            Sıfırla
          </Button>
            <Button
              variant="success"
              onClick={() => {
                onHide(false);
              }}
              className="mt-4 ml-4"
            >
              Tamam
            </Button></div>

        </div>
      </Modal.Body>
    </Modal>
  );
}
